export default __webpack_public_path__ + "scripts/resource/89f85f29b08a6606d8df261106f25e49.svg";